import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { STATES as STORE_STATES } from 'reducers/bootstrap'
import { selectBase } from 'selectors/bootstrap/selectBase'
import { selectApplication } from './selectApplication'

export const selectAccount = state =>
  selectApplication(state).account || emptyObj

export const selectIsAccountBootstrapped = createSelector(
  selectBase,
  bootstrap => bootstrap.account === STORE_STATES.LOADED
)
